<!-- ARIA Completed -->
<footer data-bs-theme="dark">
  <div class="bg-body text-body py-5">
    <div class="container">
      <div class="row justify-content-center gx-sm-5 gy-5">

        <!-- - - - About Us - - - -->
        <div class="d-flex flex-column gap-3 col-10 col-sm-12 col-md-10 col-lg-4 col-xl-5">
          <img class="logo mb-3" height="60" src="/icons/logo-white.svg" alt="Hakikat Logo" i18n-alt>
          <p class="text-center" i18n>İyiliğin Peşinde, Hakikatin İzinde<br>Mazluma Umut Ol, Geleceğe Işık Ver!</p>

          <div class="d-flex flex-wrap gap-3 justify-content-between small">
            <a class="icon-link text-decoration-none text-body-emphasis" href="https://www.facebook.com/hakikatev" rel="noopener noreferrer" target="_blank" aria-label="Facebook Sayfası" i18n-aria-label>
              <fa-icon [icon]="iconFacebook" [size]="'lg'" aria-hidden="true" />
              <span>Facebook</span>
            </a>
            <a class="icon-link text-decoration-none text-body-emphasis" href="https://www.instagram.com/hakikatev" rel="noopener noreferrer" target="_blank" aria-label="Instagram Sayfası" i18n-aria-label>
              <fa-icon [icon]="iconInstagram" [size]="'lg'" aria-hidden="true" />
              <span>Instagram</span>
            </a>
            <a class="icon-link text-decoration-none text-body-emphasis" href="https://www.tiktok.com/@hakikatev" rel="noopener noreferrer" target="_blank" aria-label="TikTok Sayfası" i18n-aria-label>
              <fa-icon [icon]="iconTiktok" [size]="'lg'" aria-hidden="true" />
              <span>TikTok</span>
            </a>
          </div>
        </div>

        <!-- - - - Contact Information - - - -->
        <div class="d-flex flex-column gap-3 col-10 col-sm-7 col-md-6 col-lg-5 col-xl-4">
          <h6 class="fw-bolder ls-4 text-body-emphasis text-uppercase" i18n>İletişim Bilgileri</h6>
          <p>
            <strong>Hakikat Sozial Kultur Bildung e.V.</strong><br>
            Nordendstraße 38-40<br>
            64546 Mörfelden-Walldorf<br>
            Deutschland
          </p>

          <div class="d-flex flex-wrap gap-3 small">
            <a class="icon-link text-decoration-none" href="tel:+4961057176116" aria-label="İletişim Telefon Numarası +49 6105 717 6116" i18n-aria-label>
              <fa-icon class="text-primary-emphasis" [icon]="iconPhone" aria-hidden="true" />
              <span class="text-body-emphasis">+49 6105 - 717 6116</span>
            </a>
            <a class="icon-link text-decoration-none" href="mailto:info@hakikatev.com" aria-label="İletişim Email Adresi" i18n-aria-label>
              <fa-icon class="text-primary-emphasis" [icon]="iconEnvelope" aria-hidden="true" />
              <span class="text-body-emphasis">info&#64;hakikatev.com</span>
            </a>
          </div>
        </div>

        <div class="d-flex flex-column gap-3 col-10 col-sm-5 col-md-4 col-lg-3 col-xl-3">
          <h6 class="fw-bolder ls-4 text-body-emphasis text-uppercase" i18n>Hızlı Bağlantılar</h6>

          <div class="list-group list-group-flush" style="font-size: 1.3rem;">
            <a class="list-group-item" [routerLink]="['/']" [fragment]="'apply'">
              <fa-icon class="me-3" [icon]="iconRight" [size]="'sm'" aria-hidden="true" />
              <span i18n>Hakikat'e Katıl</span>
            </a>
            <a class="list-group-item" [routerLink]="['/']" [fragment]="'activities'">
              <fa-icon class="me-3" [icon]="iconRight" [size]="'sm'" aria-hidden="true" />
              <span i18n>Faaliyet Alanlarımız</span>
            </a>
            <a class="list-group-item" data-bs-target="#bankAccountsModal" data-bs-toggle="modal" type="button">
              <fa-icon class="me-3" [icon]="iconRight" [size]="'sm'" aria-hidden="true" />
              <span i18n>Banka Hesap Bilgilerimiz</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="bg-black text-body py-3">
    <div class="container">
      <div class="row justify-content-center">
        <div class="d-flex flex-wrap align-items-center justify-content-between gap-2">
          <nav class="small" aria-label="Yasal Bilgiler" i18n-aria-label>
            <a class="link-light text-decoration-none" [routerLink]="['/legal/privacy-policy']" i18n>Gizlilik Politikası</a>
            <span class="mx-2" aria-hidden="true">|</span>
            <a class="link-light text-decoration-none" [routerLink]="['/legal/terms-of-service']" i18n>Kullanıcı Sözleşmesi</a>
          </nav>

          <small>
            <span>&copy; {{ year }} Hakikat Sozial Kultur Bildung e.V.</span>
            <span class="mx-2" aria-hidden="true">|</span>
            <span i18n>Tüm Hakları Saklıdır</span>
          </small>
        </div>
      </div>
    </div>
  </div>
</footer>


<!-- Bank Accounts Modal -->
<div class="modal fade" id="bankAccountsModal" data-bs-backdrop="static" data-bs-keyboard="false" role="dialog" tabindex="-1" aria-labelledby="bank-accounts-title" aria-modal="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content border-0">
      <div class="modal-header">
        <h5 id="bank-accounts-title" class="modal-title" i18n>Banka Hesapları</h5>
        <button class="btn-close" data-bs-dismiss="modal" type="button" aria-label="Kapat" i18n-aria-label></button>
      </div>
      <div class="modal-body">
        <p i18n>
          Bağışlarınızı aşağıdaki banka hesaplarına <strong>Havale/EFT</strong> yöntemiyle gerçekleştirebilirsiniz. Özel amaçlı bağışlar için, açıklama kısmına lütfen bağış türünü yazarak işlemi tamamlayınız.
        </p>

        <hr>

        <h6>Volksbank Darmstadt-Mainz</h6>
        <ul>
          <li>
            <small>
              <strong i18n>Alıcı</strong>:
              <span class="ms-1">Hakikat Sozial Kultur Bildung e.V.</span>
            </small>
          </li>
          <li>
            <small>
              <strong>IBAN (EUR)</strong>:
              <span class="ms-1">DE59 5519 0000 0546 9800 12</span>
            </small>
          </li>
          <li>
            <small>
              <strong>BIC/SWIFT</strong>:
              <span class="ms-1">MVBMDE55</span>
            </small>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>